export default __webpack_public_path__ + "static/media/coco_badge_2.c6ef078c.svg";